import { Navigate, Outlet, useParams } from "react-router-dom";

import { useKeycloakContext } from "../contexts/AuthContext";

function PrivateRoute({ children }) {
  // Get the authentication status from somewhere
  // For example, from local storage, context, or global state
  const { initialized, authenticated } = useKeycloakContext();
  const {lang} = useParams();


  if(!initialized || !authenticated){
    return <Navigate to={`/${lang}/unauthorized`} replace />;
  }

  return <Outlet/>;
}

export default PrivateRoute;